import { render } from "./NavigationMenu.vue?vue&type=template&id=7c8a36d0"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__